import { AppRouteProps } from "@bsm/component";
import { StudentHealthAndAllergiesContainer } from "./container/StudentHealthAndAllergiesContainer";

export const StudentHealthAndAllergiesRoutes: Array<AppRouteProps> = [
    {
        path: "healthAndAllergies",
        element: <StudentHealthAndAllergiesContainer />,
    },
];